export const diabetesHeroData = {
    title: "Diabetes",
    subtitle: "Type 1 & Type 2 diabetes management including insulin and oral medications",
    stats: [
        { number: "30+ Medications", label: "Medications" },
        { number: "Save up to 95%", label: "Our Price" },
        { number: "WHO-GMP Certified", label: "Quality Assurance" }
    ]
};

export const diabetesProducts = [
    {
        id: "metformin-1000mg",
        name: "Metformin 1000mg",
        genericName: "Glucophage Equivalent",
        indication: "Type 2 Diabetes",
        originalPrice: "$150",
        price: "$12",
        savings: "92%",
        description: "The first-line medication for the treatment of type 2 diabetes, particularly in people who are overweight.",
        dosage: "Take with meals to reduce gastrointestinal side effects.",
        packaging: "Pack of 60 Tablets",
        manufacturer: "Merck / Licensed Generic Manufacturers",
        storage: "Store at room temperature 20-25°C.",
        sideEffects: "Nausea, diarrhea, and stomach pain.",
        category: "Oral Medications"
    },
    {
        id: "insulin-glargine-100u",
        name: "Insulin Glargine",
        genericName: "Lantus / Basaglar",
        indication: "Diabetes Type 1 & 2",
        originalPrice: "$500",
        price: "$150",
        savings: "70%",
        description: "Long-acting basal insulin analogue, given once daily to help control the blood sugar level of those with diabetes.",
        dosage: "Subcutaneous injection once daily at the same time.",
        packaging: "5 x 3ml Prefilled Pens",
        manufacturer: "Sanofi / Eli Lilly / Generic",
        storage: "Refrigerate (2-8°C). Do not freeze.",
        sideEffects: "Hypoglycemia, injection site reactions.",
        category: "Insulin"
    },
    {
        id: "empagliflozin-25mg",
        name: "Empagliflozin 25mg",
        genericName: "Jardiance Equivalent",
        indication: "Type 2 Diabetes",
        originalPrice: "$650",
        price: "$45",
        savings: "93%",
        description: "An SGLT2 inhibitor used to lower blood sugar in adults with type 2 diabetes and reduce cardiovascular risk.",
        dosage: "10-25 mg once daily in the morning.",
        packaging: "Pack of 30 Tablets",
        manufacturer: "Boehringer Ingelheim / generic",
        storage: "Store at room temperature.",
        sideEffects: "Urinary tract infections, increased urination.",
        category: "Oral Medications"
    },
    {
        id: "sitagliptin-100mg",
        name: "Sitagliptin 100mg",
        genericName: "Januvia Equivalent",
        indication: "Type 2 Diabetes",
        originalPrice: "$500",
        price: "$38",
        savings: "92%",
        description: "A DPP-4 inhibitor that helps regulate blood sugar levels by increasing insulin when blood sugar is high.",
        dosage: "100 mg once daily with or without food.",
        packaging: "Pack of 28 Tablets",
        manufacturer: "Merck / Licensed Generic Manufacturers",
        storage: "Store at room temperature.",
        sideEffects: "Upper respiratory infection, headache.",
        category: "Oral Medications"
    },
    {
        id: "liraglutide-1.8mg",
        name: "Liraglutide 1.8mg",
        genericName: "Victoza",
        indication: "Type 2 Diabetes",
        originalPrice: "$800",
        price: "$72",
        savings: "91%",
        description: "A GLP-1 receptor agonist used to improve glycemic control and reduce the risk of major cardiovascular events.",
        dosage: "Subcutaneous injection once daily.",
        packaging: "2 x 3ml Prefilled Pens",
        manufacturer: "Novo Nordisk",
        storage: "Refrigerate until first use, then store at room temperature.",
        sideEffects: "Nausea, vomiting, and diarrhea.",
        category: "Injected (Non-Insulin)"
    },
    {
        id: "glimepiride-4mg",
        name: "Glimepiride 4mg",
        genericName: "Amaryl Equivalent",
        indication: "Type 2 Diabetes",
        originalPrice: "$200",
        price: "$10",
        savings: "95%",
        description: "A sulfonylurea medication used to treat type 2 diabetes by stimulating insulin release from the pancreas.",
        dosage: "1-4 mg once daily with breakfast.",
        packaging: "Pack of 30 Tablets",
        manufacturer: "Sanofi / Licensed Generic Manufacturers",
        storage: "Store at room temperature.",
        sideEffects: "Low blood sugar (hypoglycemia), dizziness.",
        category: "Oral Medications"
    },
    {
        id: "pioglitazone-45mg",
        name: "Pioglitazone 45mg",
        genericName: "Actos Equivalent",
        indication: "Type 2 Diabetes",
        originalPrice: "$300",
        price: "$26",
        savings: "91%",
        description: "A thiazolidinedione (TZD) used to increase insulin sensitivity in muscle and adipose tissue.",
        dosage: "15-45 mg once daily.",
        packaging: "Pack of 30 Tablets",
        manufacturer: "Takeda / Licensed Generic Manufacturers",
        storage: "Store at room temperature.",
        sideEffects: "Upper respiratory tract infection, headache.",
        category: "Oral Medications"
    },
    {
        id: "dapagliflozin-10mg",
        name: "Dapagliflozin 10mg",
        genericName: "Farxiga Equivalent",
        indication: "Type 2 Diabetes",
        originalPrice: "$550",
        price: "$42",
        savings: "92%",
        description: "An SGLT2 inhibitor that helps the kidneys get rid of glucose from your bloodstream through urine.",
        dosage: "5-10 mg once daily in the morning.",
        packaging: "Pack of 30 Tablets",
        manufacturer: "AstraZeneca / generic",
        storage: "Store at room temperature.",
        sideEffects: "Yeast infections, dehydration.",
        category: "Oral Medications"
    },
    {
        id: "canagliflozin-300mg",
        name: "Canagliflozin 300mg",
        genericName: "Invokana Equivalent",
        indication: "Type 2 Diabetes",
        originalPrice: "$600",
        price: "$44",
        savings: "93%",
        description: "Used to manage type 2 diabetes and reduce the risk of major heart-related events.",
        dosage: "100-300 mg once daily before the first meal.",
        packaging: "Pack of 30 Tablets",
        manufacturer: "Janssen / generic",
        storage: "Store at room temperature.",
        sideEffects: "Urinary tract infections, increased thirst.",
        category: "Oral Medications"
    },
    {
        id: "dulaglutide-1.5mg",
        name: "Dulaglutide 1.5mg",
        genericName: "Trulicity",
        indication: "Type 2 Diabetes",
        originalPrice: "$850",
        price: "$80",
        savings: "91%",
        description: "A GLP-1 receptor agonist administered once weekly for the treatment of type 2 diabetes.",
        dosage: "Subcutaneous injection once a week.",
        packaging: "4 x 0.5ml Pens",
        manufacturer: "Eli Lilly",
        storage: "Store in refrigerator (2-8°C).",
        sideEffects: "Stomach pain, nausea, and vomiting.",
        category: "Injected (Non-Insulin)"
    },
    {
        id: "semaglutide-1mg",
        name: "Semaglutide 1mg",
        genericName: "Ozempic",
        indication: "Type 2 Diabetes",
        originalPrice: "$1,000",
        price: "$70",
        savings: "93%",
        description: "A glucagon-like peptide-1 (GLP-1) receptor agonist that helps your body release insulin when blood sugar is high.",
        dosage: "Subcutaneous injection once weekly.",
        packaging: "Prefilled Pen",
        manufacturer: "Novo Nordisk",
        storage: "Store in refrigerator until open.",
        sideEffects: "Nausea, diarrhea, and vomiting.",
        category: "Injected (Non-Insulin)"
    },
    {
        id: "insulin-aspart-100u",
        name: "Insulin Aspart",
        genericName: "NovoLog / Fiasp",
        indication: "Diabetes Type 1 & 2",
        originalPrice: "$500",
        price: "$140",
        savings: "72%",
        description: "Fast-acting insulin used to control high blood sugar during meals.",
        dosage: "Inject subcutaneously 5-10 minutes before a meal.",
        packaging: "5 x 3ml Prefilled Pens",
        manufacturer: "Novo Nordisk / Generic",
        storage: "Store in refrigerator (2-8°C).",
        sideEffects: "Hypoglycemia, weight gain.",
        category: "Insulin"
    },
    {
        id: "insulin-lispro-100u",
        name: "Insulin Lispro",
        genericName: "Humalog / Admelog",
        indication: "Diabetes Type 1 & 2",
        originalPrice: "$480",
        price: "$135",
        savings: "72%",
        description: "Rapid-acting insulin used to lower blood glucose levels at mealtime.",
        dosage: "Inject subcutaneously within 15 minutes before or immediately after a meal.",
        packaging: "5 x 3ml Prefilled Pens",
        manufacturer: "Eli Lilly / Sanofi / Generic",
        storage: "Refrigerate until first use.",
        sideEffects: "Low blood sugar, injection site itching.",
        category: "Insulin"
    },
    {
        id: "insulin-degludec-100u",
        name: "Insulin Degludec",
        genericName: "Tresiba FlexTouch",
        indication: "Diabetes Type 1 & 2",
        originalPrice: "$550",
        price: "$165",
        savings: "70%",
        description: "Ultra-long-acting basal insulin that lasts for at least 42 hours.",
        dosage: "Inject subcutaneously once daily at any time of day.",
        packaging: "5 x 3ml Pens",
        manufacturer: "Novo Nordisk",
        storage: "Store in refrigerator.",
        sideEffects: "Hypoglycemia, upper respiratory infection.",
        category: "Insulin"
    },
    {
        id: "linagliptin-5mg",
        name: "Linagliptin 5mg",
        genericName: "Tradjenta Equivalent",
        indication: "Type 2 Diabetes",
        originalPrice: "$450",
        price: "$35",
        savings: "92%",
        description: "A DPP-4 inhibitor used along with diet and exercise to lower blood sugar.",
        dosage: "5 mg once daily with or without food.",
        packaging: "Pack of 30 Tablets",
        manufacturer: "Boehringer Ingelheim / generic",
        storage: "Store at room temperature.",
        sideEffects: "Nasopharyngitis, hypoglycemia.",
        category: "Oral Medications"
    },
    {
        id: "saxagliptin-5mg",
        name: "Saxagliptin 5mg",
        genericName: "Onglyza Equivalent",
        indication: "Type 2 Diabetes",
        originalPrice: "$400",
        price: "$32",
        savings: "92%",
        description: "Used to help control blood sugar in people with type 2 diabetes by increasing insulin after meals.",
        dosage: "2.5 or 5 mg once daily.",
        packaging: "Pack of 30 Tablets",
        manufacturer: "AstraZeneca / generic",
        storage: "Store at room temperature.",
        sideEffects: "Upper respiratory tract infection, headache.",
        category: "Oral Medications"
    },
    {
        id: "vildagliptin-50mg",
        name: "Vildagliptin 50mg",
        genericName: "Galvus Equivalent",
        indication: "Type 2 Diabetes",
        originalPrice: "$420",
        price: "$28",
        savings: "93%",
        description: "An oral anti-hyperglycemic agent that works by protecting the incretin hormones.",
        dosage: "50 mg once or twice daily.",
        packaging: "Pack of 28 Tablets",
        manufacturer: "Novartis / generic",
        storage: "Protect from moisture and heat.",
        sideEffects: "Dizziness, headache, and nausea.",
        category: "Oral Medications"
    },
    {
        id: "alogliptin-25mg",
        name: "Alogliptin 25mg",
        genericName: "Nesina Equivalent",
        indication: "Type 2 Diabetes",
        originalPrice: "$440",
        price: "$32",
        savings: "93%",
        description: "A selective DPP-4 inhibitor used to improve blood sugar control.",
        dosage: "25 mg once daily.",
        packaging: "Pack of 30 Tablets",
        manufacturer: "Takeda / generic",
        storage: "Store at room temperature.",
        sideEffects: "Headache, nasopharyngitis, and upper respiratory tract infection.",
        category: "Oral Medications"
    },
    {
        id: "glipizide-10mg",
        name: "Glipizide 10mg",
        genericName: "Glucotrol Equivalent",
        indication: "Type 2 Diabetes",
        originalPrice: "$240",
        price: "$15",
        savings: "94%",
        description: "A sulfonylurea that helps the body release more insulin to lower blood glucose.",
        dosage: "5-10 mg 30 minutes before bridge-meal.",
        packaging: "Bottle of 100 Tablets",
        manufacturer: "Pfizer / Licensed Generic Manufacturers",
        storage: "Store at room temperature.",
        sideEffects: "Hypoglycemia, nausea, and diarrhea.",
        category: "Oral Medications"
    },
    {
        id: "glyburide-5mg",
        name: "Glyburide 5mg",
        genericName: "Micronase Equivalent",
        indication: "Type 2 Diabetes",
        originalPrice: "$220",
        price: "$14",
        savings: "94%",
        description: "Helps control blood sugar levels by stimulating the pancreas to secrete insulin.",
        dosage: "1.25-20 mg daily in single or divided doses.",
        packaging: "Pack of 30 Tablets",
        manufacturer: "Licensed Generic Manufacturers",
        storage: "Store at room temperature.",
        sideEffects: "Low blood sugar, heart burn, and nausea.",
        category: "Oral Medications"
    },
    {
        id: "repaglinide-2mg",
        name: "Repaglinide 2mg",
        genericName: "Prandin Equivalent",
        indication: "Type 2 Diabetes",
        originalPrice: "$350",
        price: "$22",
        savings: "94%",
        description: "Used to manage blood sugar by triggering the pancreas to produce more insulin.",
        dosage: "Take 15-30 minutes before each meal.",
        packaging: "Pack of 90 Tablets",
        manufacturer: "Novo Nordisk / generic",
        storage: "Store at room temperature.",
        sideEffects: "Hypoglycemia, weight gain, and headache.",
        category: "Oral Medications"
    },
    {
        id: "nateglinide-120mg",
        name: "Nateglinide 120mg",
        genericName: "Starlix Equivalent",
        indication: "Type 2 Diabetes",
        originalPrice: "$340",
        price: "$21",
        savings: "94%",
        description: "Helps the body release insulin quickly after a meal to prevent spikes.",
        dosage: "120 mg three times daily before meals.",
        packaging: "Pack of 90 Tablets",
        manufacturer: "Novartis / generic",
        storage: "Store at room temperature.",
        sideEffects: "Upper respiratory infection, dizziness.",
        category: "Oral Medications"
    },
    {
        id: "acarbose-100mg",
        name: "Acarbose 100mg",
        genericName: "Precose Equivalent",
        indication: "Type 2 Diabetes",
        originalPrice: "$230",
        price: "$15",
        savings: "93%",
        description: "Works by slowing the digestion of carbohydrates in the small intestine.",
        dosage: "Take with the first bite of each main meal.",
        packaging: "Pack of 30 Tablets",
        manufacturer: "Bayer / generic",
        storage: "Store protected from moisture.",
        sideEffects: "Flatulence, diarrhea, and abdominal pain.",
        category: "Oral Medications"
    },
    {
        id: "insulin-nph-100u",
        name: "Insulin NPH",
        genericName: "Humulin N / Novolin N",
        indication: "Diabetes Type 1 & 2",
        originalPrice: "$200",
        price: "$110",
        savings: "45%",
        description: "Intermediate-acting insulin used to treat diabetes mellitus.",
        dosage: "Administer subcutaneously once or twice daily.",
        packaging: "1 vial (10ml)",
        manufacturer: "Eli Lilly / Novo Nordisk",
        storage: "Store in refrigerator.",
        sideEffects: "Hypoglycemia, hypokalemia.",
        category: "Insulin"
    },
    {
        id: "insulin-regular-100u",
        name: "Insulin Regular",
        genericName: "Humulin R / Novolin R",
        indication: "Diabetes Type 1 & 2",
        originalPrice: "$180",
        price: "$100",
        savings: "44%",
        description: "Short-acting insulin used for glycaemic control in diabetes.",
        dosage: "Subcutaneous injection 30 minutes before a meal.",
        packaging: "1 vial (10ml)",
        manufacturer: "Eli Lilly / Novo Nordisk",
        storage: "Store in refrigerator.",
        sideEffects: "Low blood sugar, injection site reactions.",
        category: "Insulin"
    },
    {
        id: "glimepiride-1mg",
        name: "Glimepiride 1mg",
        genericName: "Amaryl Starter",
        indication: "Type 2 Diabetes",
        originalPrice: "$150",
        price: "$8",
        savings: "95%",
        description: "Low dose sulfonylurea used for initial therapy or combination.",
        dosage: "1 mg once daily with breakfast.",
        packaging: "Pack of 30 Tablets",
        manufacturer: "Generic",
        storage: "Store at room temperature.",
        sideEffects: "Low blood sugar.",
        category: "Oral Medications"
    },
    {
        id: "sitagliptin-50mg",
        name: "Sitagliptin 50mg",
        genericName: "Januvia 50",
        indication: "Type 2 Diabetes",
        originalPrice: "$350",
        price: "$25",
        savings: "93%",
        description: "Intermediate dose DPP-4 inhibitor.",
        dosage: "50 mg once daily.",
        packaging: "Pack of 30 Tablets",
        manufacturer: "Merck / generic",
        storage: "Store at room temperature.",
        sideEffects: "Headache.",
        category: "Oral Medications"
    },
    {
        id: "janumet-50-1000",
        name: "Metformin / Sitagliptin",
        genericName: "Janumet Equivalent",
        indication: "Type 2 Diabetes",
        originalPrice: "$500",
        price: "$42",
        savings: "92%",
        description: "Combination medicine containing two different medications to improve glycaemic control.",
        dosage: "One tablet twice daily with meals.",
        packaging: "Pack of 60 Tablets",
        manufacturer: "Merck / generic",
        storage: "Store at room temperature.",
        sideEffects: "Nausea, common cold symptoms.",
        category: "Combination"
    },
    {
        id: "xigduo-5-1000",
        name: "Empagliflozin / Metformin",
        genericName: "Synjardy Equivalent",
        indication: "Type 2 Diabetes",
        originalPrice: "$550",
        price: "$45",
        savings: "92%",
        description: "Combines an SGLT2 inhibitor and metformin to lower blood glucose.",
        dosage: "One tablet twice daily with meals.",
        packaging: "Pack of 60 Tablets",
        manufacturer: "Boehringer Ingelheim / generic",
        storage: "Store at room temperature.",
        sideEffects: "Diarrhea, nausea, and increased urination.",
        category: "Combination"
    }
];

export const diabetesCategories = [
    "All Categories",
    "Oral Medications",
    "Insulin",
    "Injected (Non-Insulin)",
    "Combination"
];

export const diabetesTrustBadges = [
    { icon: "ShieldCheck", text: "100% Quality Assurance" },
    { icon: "Plane", text: "Cold Chain Shipping Available" },
    { icon: "Award", text: "Global Standards Compliant" }
];

export const diabetesFAQs = [
    {
        question: "How do you ship insulin to ensure it stays cold?",
        answer: "Insulin is shipped using medical-grade cold chain packaging, including insulated thermal boxes and gel packs that maintain the required 2-8°C temperature range throughout transit."
    },
    {
        question: "Is generic Metformin as effective as the branded version?",
        answer: "Yes, generic Metformin is bioequivalent to Glucophage, meaning it has the same active ingredient and provides the same therapeutic effect at a fraction of the cost."
    },
    {
        question: "Do I need a prescription to order diabetes medications?",
        answer: "Yes, for safety and regulatory compliance, we require a valid prescription from your healthcare provider for all insulin and prescription medications."
    }
];

export const diabetesTestimonials = [
    {
        name: "David S.",
        country: "USA",
        savings: "$6,500 annually",
        condition: "Type 1 Diabetes",
        medication: "Insulin Glargine / Aspart",
        testimonial: "The cost of insulin in the US was becoming unbearable. MediSeller has been a lifesaver, providing the exact same insulin I use for 70% less. The cold chain shipping is always perfect.",
        rating: 5
    },
    {
        name: "Maria G.",
        country: "UK",
        savings: "£400/month",
        condition: "Type 2 Diabetes",
        medication: "Sitagliptin / Metformin",
        testimonial: "I was hesitant about ordering online, but the quality of the medications and the customer service has been outstanding. My HbA1c levels have remained consistent.",
        rating: 5
    }
];

export const diabetesSectionContent = {
    midPageCTA: {
        title: "Complete Diabetes Care Solutions",
        description: "From advanced SGLT2 inhibitors to essential insulin therapies, we offer a comprehensive range of medications to help you manage your blood sugar levels effectively safely.",
        whatsappText: "Inquire Now",
        requestText: "Upload Prescription"
    },
    testimonials: {
        title: "Patient Success Stories",
        description: "Join thousands of patients who have successfully managed their diabetes while reducing their healthcare expenses."
    },
    faqs: {
        title: "Diabetes Care FAQ",
        description: "Important information about insulin storage, generic quality, and global shipping standards."
    },
    finalCTA: {
        title: "Take Control of Your Diabetes",
        description: "Access affordable, authentic diabetic medications with secure global shipping and specialized cold-chain logistics for insulin.",
        whatsappText: "Chat with Pharmacist",
        requestText: "Search Your Medicine"
    }
};
